import api from "./api";
import { toSearchFilter } from "utils";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_PRINT_NAS_LIST = API_URL_VERSION + 'lotes/imprimir-nas'
export const ENDPOINT_PRINT_NAS = API_URL_VERSION + 'print-nas'
export const ENDPOINT_PRINT_NAS_GET_DETAIL_UPDATE = API_URL_VERSION + 'print-nas/'
export const ENDPOINT_PRINT_NA = API_URL_VERSION + 'lotes/imprimir-na-pdf'
export const ENDPOINT_CONFIRM_SHIPPING_NA = API_URL_VERSION + "lotes/confirmar-envio-na"
export const ENDPOINT_RESPONSE_FILE_NA = API_URL_VERSION + "lotes/arquivo-resposta-correios-na"
export const ENDPOINT_REPORT_BATCH = API_URL_VERSION + "lotes/imprimir-detalhes-lote-na-pdf"
export const ENDPOINT_REPORT_EDITAL_BATCH = API_URL_VERSION + "lotes/imprimir-edital-na-pdf"

export const printNAsService = {
    list: async (params = {}) => {
        try {
            const searchParams = toSearchFilter(params);
            const response = await api.post(ENDPOINT_PRINT_NAS_LIST, searchParams);
            return response?.data ?? [];
        } catch (error) {
            throw error.response?.data?.message || "error.print-nas.list";
        }
    },

    findMany: async (data) => {
        try {
            const response = await api.get(ENDPOINT_PRINT_NAS_LIST, data);
            return response.data;
        } catch (error) {
            console.log(error)
            throw error.response?.data?.message || 'error.print-nas.findmany';
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_PRINT_NAS, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'error.print-nas.create';
        }
    },

    find: async (id: number) => {
        try {
            const response = await api.get(`${ENDPOINT_PRINT_NAS_GET_DETAIL_UPDATE}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'error.print-nas.find';
        }
    },

    update: async (id: number, data) => {
        try {
            const response = await api.put(`${ENDPOINT_PRINT_NAS_GET_DETAIL_UPDATE}${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'error.print-nas.update';
        }
    },

    printNa: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_PRINT_NA}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || 'print-nas.messages.errors.print-na';
        }
    },

    getResponseFileNa: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_RESPONSE_FILE_NA}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || 'print-nas.messages.errors.response-file-na';
        }
    },

    confirmShippingNa: async (id) => {
        try {
            const response = await api.put(`${ENDPOINT_CONFIRM_SHIPPING_NA}/${id}`)
            return response.data;
        } catch (error) {
            throw error.response?.data?.erros_validacao || 'print-nas.messages.errors.confirm-shipping-na';
        }
    },

    getReportNa: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_REPORT_BATCH}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || 'print-nas.messages.errors.details-file-na';
        }
    },

    getEditalReportNA: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_REPORT_EDITAL_BATCH}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || 'print-nas.messages.errors.edital-file-na';
        }
    }

};
